import { Button, Stack, Typography } from '@karma/components';
import { CheckInCircleIconFilled } from '@karma/components/icons';
import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useContext } from 'react';
import Alooma from 'services/alooma';
import * as ALOOMA from 'consts/alooma';
import { getUserEmail } from 'store/user/selectors';
import useAction from 'hooks/useAction';
import { pushBackGiftCardNoEmailModal } from 'store/modals/actions';
import { ResolutionTypeContext } from 'contexts/ResolutionTypeContext';
import { Body } from './ModalBodyGiftCardEmailSend.style';

const ModalBodyGiftCardEmailSend = ({ closeModal }) => {
  const { t } = useTranslation();
  const contextDataAttrs = Alooma.useContextDataAttrs();
  const { isPhoneResolution } = useContext(ResolutionTypeContext);
  const email = useSelector(getUserEmail);
  const pushBackGiftCardNoEmailModallFunc = useAction(pushBackGiftCardNoEmailModal);

  const clickHandler = () => {
    closeModal();
    pushBackGiftCardNoEmailModallFunc();
  };

  return (
    <Body>
      <CheckInCircleIconFilled width={60} height={60} />
      <Stack spacing={8} direction="column">
        <Typography variant="h3">{t('app:verificationEmailSent')}</Typography>
        <Typography variant="paragraphLarge">
          <Trans i18nKey="app:weSentVerificationEmailTo" values={{ email }} components={{ strong: <strong /> }} />
          <br />
          {t('app:pleaseVerifyYourEmail')}
        </Typography>
      </Stack>
      <Button
        size={isPhoneResolution ? 'small' : 'semiSmall'}
        type="underlinedText"
        onClick={clickHandler}
        {...contextDataAttrs}
        data-alooma-element={ALOOMA.ELEMENTS.DID_NOT_GET_EMAIL}
        fullWidth
      >
        {t('app:didNotGetEmail')}
      </Button>
    </Body>
  );
};

export default ModalBodyGiftCardEmailSend;
